export default {
  list: [],
  count: 0,
  has_next: false,
  next_page: 0,
  offset: 0,
  page_size: 20,
  search: "",
  voice_filter: "",
  is_loading: false,
  selected: null,
  voices: [],
};
